/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods200,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods401,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods500,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsPathParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryResponse,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsPathParams>;

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods500>;

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethods200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidAvailablePaymentMethodsQueryResponse>;
